<template>
  <div class="box">
    <div class="boxnav mapc" style="height: 653px; position: relative">
      <div class="mapnav">
        <ul>
          <li>
            <div>
              <span>昨日收入</span>
              <p>{{ currencyFormat(revenueSummary.PredayRevenue) }}</p>
            </div>
          </li>
          <li>
            <div>
              <span>今日收入</span>
              <p>{{ currencyFormat(revenueSummary.CurrentDayRevenue) }}</p>
            </div>
          </li>
          <li>
            <div>
              <span>上月收入</span>
              <p>{{ currencyFormat(revenueSummary.PremonthRevenue) }}</p>
            </div>
          </li>
          <li>
            <div>
              <span>本月收入</span>
              <p>{{ currencyFormat(revenueSummary.CurrentMonthRevenue) }}</p>
            </div>
          </li>
          <li>
            <div>
              <span>总收入</span>
              <p>{{ currencyFormat(revenueSummary.TotalRevenue) }}</p>
            </div>
          </li>
        </ul>
      </div>
      <!-- <div class="mapnav2">
        <div class="box">
          <div class="block-title">收入趋势</div>
          <div id="sysx1" ref="trendDiv" class="boxnav" style="height: 130px"></div>
        </div>
      </div> -->
      <div id="map" ref="mapDiv" class="map"></div>
    </div>
  </div>
</template>

<script lang="jsx">
import * as echarts from 'echarts';
// import { onBeforeUnmount, onMounted, ref, shallowRef } from 'vue';

// import { RevenueSummaryModel, StationInfoModel } from '@/api/model/overviewModel';

// import { getRevenueSummary, getStationMaps } from '@/api/overview';
// import chinaMap from './china.js';
// const chinaMap = require('./china.js');
import chinaMap from './china.json';

export default {
	data() {
		return {
			mapCharts: null,
			trendCharts: null,
			revenueSummary: {},
			timer: null,
		}
	},
	mounted() {
		this.mapCharts = echarts.init(this.$refs.mapDiv);
		// this.trendCharts = echarts.init(this.$refs.trendDiv);
		echarts.registerMap('china', chinaMap);
		this.mapCharts.setOption(mapChartOption);
		// this.trendCharts.setOption(trendChartOption);
		window.addEventListener('resize', () => this.mapCharts.resize());
	},
	beforeUnmount() {
		if (this.timer) clearInterval(this.timer);
		this.timer = undefined;
		if (this.mapCharts) this.mapCharts.distroy();
		// if (this.trendCharts) this.trendCharts.distroy();
	},
	methods: {
		setData(stationsInfo, revenueSummaryModel) {
			if (stationsInfo) {
				mapChartOption.series[0].data = stationsInfo;
				mapChartOption.series[0].data.forEach((item) => {
					item.name = item.StationName;
					item.value = [item.Longitude, item.Latitude, item.TotalDevNum];
				});
				this.mapCharts.setOption(mapChartOption);
			}
			if (revenueSummaryModel) {
				this.revenueSummary = revenueSummaryModel;
				trendChartOption.xAxis[0].data = revenueSummaryModel.TrendCurves.TimePoints;
				trendChartOption.series[0].data = revenueSummaryModel.TrendCurves.MonthRevenues;
				// this.trendCharts.setOption(trendChartOption);
			}
		},
		currencyFormat(value) {
			if (!value) value = 0;
			const formatter = new Intl.NumberFormat('zh-CN', { useGrouping: true });
			return formatter.format(value);
		}
	}
}

let mapChartOption = {
  // backgroundColor: '#404a59',
  tooltip: {
    trigger: 'item',
  },
  geo: {
    map: 'china',
    label: {
      show: false,
    },
    emphasis: {
      label: {
        show: false,
      },
      itemStyle: {
        areaColor: 'rgba(2,37,101,.8)',
      },
    },
		center: [103.97, 35.71],
    roam: false,
    zoom: 1.6,
    itemStyle: {
      areaColor: 'rgba(2,37,101,.5)',
      borderColor: 'rgba(112,187,252,.5)',
    },
    tooltip: {
      show: false,
    },
  },
  series: [
    {
      name: '充电站',
      type: 'scatter',
      coordinateSystem: 'geo',
      data: [], // convertData(data),
      symbolSize(val) {
        return Math.min(val[2] / 20 + 12, 20);
      },
      label: {
        formatter: '{b}',
        position: 'right',
        show: false,
      },
      itemStyle: {
        color: '#ffeb7b',
      },
      emphasis: {
        label: {
          show: false,
        },
      },
      tooltip: {
        show: true,
        trigger: 'item',
        backgroundColor: 'transparent',
        borderColor: 'transparent',
        boorderWidth: 0,
        padding: 0,
        formatter: (params) => {
          // console.log(params.name, params, ticket, callback);
          return `
        <div class="card">
          <div class="card-header">${params.data.StationName}</div>
          <div class="card-body">
            <div class="card d-inline-block">
              <div class="card-body">
                <span>充电枪总数</span>
                <p class="">${params.data.TotalDevNum}</p>
              </div>
            </div>
            <div class="card d-inline-block">
              <div class="card-body">
                <span>直流枪数量</span>
                <p class="layui-badge1">${params.data.ZhiliuDevNum}</p>
              </div>
            </div>
            <div class="card d-inline-block">
              <div class="card-body">
                <span>交流枪数量</span>
                <p class="layui-badge1">${params.data.JiaoliuDevNum}</p>
              </div>
            </div>
            <hr style="margin:5px 0px; color: rgba(149, 184, 231, 0.5); opacity: 0.3" />
            <div class="card d-inline-block">
              <div class="card-body">
                <span>充电中数量</span>
                <p class="work-status-charging">${params.data.WorkingDevNum}</p>
              </div>
            </div>
            <div class="card d-inline-block">
              <div class="card-body">
                <span>空闲中数量</span>
                <p class="work-status-standby">${params.data.StandbyDevNum}</p>
              </div>
            </div>
            <div class="card d-inline-block">
              <div class="card-body">
                <span>故障中数量</span>
                <p class="work-status-fault">${params.data.BreakdownDevNum}</p>
              </div>
            </div>
          </div>
        </div>
      `;
        },
      },
    },
  ],
};

let trendChartOption = {
  //  backgroundColor: '#00265f',
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'shadow',
    },
  },
  grid: {
    left: '0%',
    top: '10px',
    right: '0%',
    bottom: '0',
    containLabel: true,
  },
  xAxis: [
    {
      type: 'category',
      data: [],
      axisLine: {
        show: true,
        lineStyle: {
          color: 'rgba(255,255,255,.1)',
          width: 1,
          type: 'solid',
        },
      },
      axisTick: {
        show: false,
      },
      axisLabel: {
        interval: 0,
        // rotate:50,
        show: true,
        splitNumber: 5,
        color: 'rgba(255,255,255,.6)',
        fontSize: '12',
      },
    },
  ],
  yAxis: [
    {
      type: 'value',
      scale: true,
      axisLabel: {
        // formatter: '{value} %'
        show: true,
        color: 'rgba(255,255,255,.6)',
        fontSize: '12',
      },
      axisTick: {
        show: false,
      },
      axisLine: {
        show: true,
        lineStyle: {
          color: 'rgba(255,255,255,.1	)',
          width: 1,
          type: 'solid',
        },
      },
      splitLine: {
        show: false,
        lineStyle: {
          color: 'rgba(255,255,255,.1)',
        },
      },
    },
  ],
  series: [
    {
      name: '收入趋势',
      type: 'line',
      // smooth: true,
      data: [],

      itemStyle: {
        color: '#2f89cf',
        opacity: 1,

        barBorderRadius: 5,
      },
    },
  ],
};
</script>

<style type="less" scoped>
@import '../style.css';
.content {
  background: -webkit-radial-gradient(50% 35%, farthest-corner, #034f8e, #034987, #02366d, #002353);
  color: white;
}
.mapnav li div span::after {
  content: '(元)';
  font-size: 0.7rem;
  color: rgb(247, 116, 116);
  opacity: 0.9;
}

/deep/ .work-status-standby {
  color: #7cfc00 !important;
}

/deep/ .work-status-offline {
  color: #c2a400 !important;
}

/deep/ .work-status-fault {
  color: red !important;
}

/deep/ .work-status-charging {
  color: #007cfc !important;
}

/deep/ .card {
  background-color: rgba(10, 50, 122, 0.75);
  border-radius: 8px;
  border: rgba(245, 245, 245, 0.8) 1px solid;
  color: rgba(245, 245, 245, 0.8);
}

/deep/ .card .card {
  border: 0;
}

/deep/ .card .card + .card::before {
  border-left: 1px white solid;
  /* height: 35px; */
  /* content: ' '; */
  /* float: left; */
  position: absolute;
  display: block;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  content: '';
}

/deep/ .card-header {
  padding: 8px 10px;
  display: inline-block;
  white-space: normal;
  width: 300px;
  max-width: 300px;
}

/deep/ .card-body {
  padding: 10px;
}

/deep/ .card-body > div {
  display: inline-block;
}

/deep/ .card-body p {
  font-size: 24px;
  color: teal;
}
</style>
